module.exports = __webpack_public_path__ + "post-listing-block-6-image-step1-3Kldgxx.png";